/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { exactly } from 'purify-ts/Codec';
import { UIPrefsStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var SubmissionTabPreset;
(function (SubmissionTabPreset) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.PREF_NAME = 'submission_tab_preset';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.codec = exactly('smart', 'code', 'feedback-overview', 'auto-test', 'peer-feedback');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.DEFAULT_VALUE = 'smart';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.load = () => UIPrefsStore.loadUIPreference({ preference: SubmissionTabPreset.PREF_NAME });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.set = (value) => UIPrefsStore.patchUIPreference({
        preference: SubmissionTabPreset.PREF_NAME,
        value,
    });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionTabPreset.get = () => {
        const pref = UIPrefsStore.getUIPref()(SubmissionTabPreset.PREF_NAME, SubmissionTabPreset.codec);
        const status = pref.status;
        switch (status) {
            case 'not-loaded':
            case 'not-present':
                return SubmissionTabPreset.DEFAULT_VALUE;
            case 'not-valid':
                utils.sentry.withSentry(sentry => sentry.captureException(pref.error));
                return SubmissionTabPreset.DEFAULT_VALUE;
            case 'valid':
                return pref.value;
            default:
                throw utils.AssertionError.assertNever(status);
        }
    };
})(SubmissionTabPreset || (SubmissionTabPreset = {}));
